export default __webpack_public_path__ + "static/media/icon-profile.30b20d20.svg";